export const SET_PRODUCTION_STATUS_AUTHORS_FILTER =
  'SET_PRODUCTION_STATUS_AUTHORS_FILTER'
export const SET_PRODUCTION_STATUS_COURSE_FILTER =
  'SET_PRODUCTION_STATUS_COURSE_FILTER'
export const SET_PRODUCTION_STATUS_LEVELS_FILTER =
  'SET_PRODUCTION_STATUS_LEVELS_FILTER'
export const SET_PRODUCTION_STATUS_TAG_FILTERS =
  'SET_PRODUCTION_STATUS_TAG_FILTERS'
export const SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER =
  'SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER'
export const SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS =
  'SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS'
export const SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS =
  'SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS'
export const CLEAR_PRODUCTION_STATUS_FILTERS = 'CLEAR_PRODUCTION_STATUS_FILTERS'

export function setAuthorsFilter(authorIds) {
  return {
    type: SET_PRODUCTION_STATUS_AUTHORS_FILTER,
    authors_id_in: authorIds
  }
}

export function setCourseFilter(courseId) {
  return {
    type: SET_PRODUCTION_STATUS_COURSE_FILTER,
    mock_course_id_in: courseId
  }
}

export function setLevelFilter(levels) {
  return {
    type: SET_PRODUCTION_STATUS_LEVELS_FILTER,
    mock_level_id_in: levels
  }
}

export function clearProductionStatusFilters() {
  return {
    type: CLEAR_PRODUCTION_STATUS_FILTERS
  }
}

export function setTagFilters(tagIds: Array<number>): Action {
  return {
    type: SET_PRODUCTION_STATUS_TAG_FILTERS,
    questtags_id_in: tagIds
  }
}

export function setPrimarySubjectFilter(subjects: Array<string>): Action {
  return {
    type: SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER,
    quest_subject_id_in: subjects
  }
}

export function setAssignedToFilters(assignedToIds: Array<number>): Action {
  return {
    type: SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS,
    assigned_to_id_in: assignedToIds
  }
}

export function setTargetGradeLevelFilter(gradeLevels) {
  return {
    type: SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS,
    grade_levels_id_in: gradeLevels
  }
}



// WEBPACK FOOTER //
// ./src/actions/productionstatusfilters.js